import React from "react";
import {push} from 'react-router-redux';
import {store} from '../../store/store';
import {Button, Card, PullToRefresh, WhiteSpace, Toast, Tabs, Checkbox} from 'antd-mobile';
import MobileWrapper from '../../layouts/MobileWrapper';
import OvertimeApprovalService from "../../services/Approval/overtime-approval-service";
import approvalCenter from "../../services/Employee/approval-center-service";
import ReactAbstract from "../../components/abstract/React.abstract";
import './style.css';
import { connect } from 'react-redux';
// const tabs = [
//   { title: '待审批', key:"selectApprovalAction" },
//   { title: '抄送给我的', key:"selectCCAction" },
//   { title: '已审批记录', key:"selectApprovedAction" }
// ];


const CheckboxItem = Checkbox.CheckboxItem;

class MobileApprovalOvertimeList extends ReactAbstract {


    dataMode = 1

    state = {
        data: {
            Data: []
        },
        pageSize:0,
        cardListRefreshing: false,
        cardListHeight: document.documentElement.clientHeight,
        filters: {
            page: 1
        },
        tabIndex: "selectApprovalAction",
        document_id:[],
        currentModalStatus:false,
        suggestion:"",
        tabs:[]
    }
    
    actions = {
        selectAction: approvalCenter.fetchOvertimeApprovalPending,
        selectApprovalAction: approvalCenter.fetchOvertimeApprovalPending,
        selectCCAction: approvalCenter.fetchOvertimeCcToMe,
        selectApprovedAction: approvalCenter.fetchOvertimeApproved,
    }



    changeTabIndex = value => this.setState({
        dataStatus: "unload",
        filters: {page: 1},
        tabIndex: value.key,
        data: {Data: []}
    }, () => {
        this.actions.selectAction = this.actions[value.key]
        this.publicChange();
    })

    publicSelect = callback => {
        let gets = {};
        Object.keys(this.state.filters).forEach(key => {
            if (this.state.filters[key]) {
                gets[key] = this.state.filters[key];
            }
        });
        let apoLoadStatus = false;
        if ("function" === typeof this.actions.selectAction) {
            this.actions.selectAction(gets, res => {
                apoLoadStatus = true;
                this.setState({
                    dataStatus: "loaded",
                    data: {
                        ...this.state.data,
                        ...res.data.Object,
                        Data: [
                            ...this.state.data.Data,
                            ...res.data.Object.Data
                        ]
                    }
                }, () => {
                    if ("function" === typeof callback) {
                        callback();
                    }
                })
            }, err => this.setState({dataStatus: "error"}))
            let timeoutIndex = setTimeout(() => {
                clearTimeout(timeoutIndex);
                if (!apoLoadStatus) {
                    this.setState({dataStatus: "loading"})
                }
            }, 100);
        }else{
            this.handleError("Child class's actions selectAction is required!");
        }       
    }
    allApproval = (approval_status) =>{
        let posts={
            approval_status:approval_status
        }
        // let gets = {
        //     page:this.state.filters.page
        // }
        // let i = 0;
        let batch_approvalsData ={
            document_id: this.state.document_id
        }

        posts.batch_approvals=batch_approvalsData;
        
        OvertimeApprovalService.updateOvertimeBatchApproval(posts, res => {
            if (res.data.Success) {
                Toast.success("操作成功", 4);
                this.actions.changeAction({}, "reload") 
            } else if(res.data.Errors){
                Toast.fail(`操作失败：${res.data.Errors}`, 4);
            } else {
                Toast.fail(`操作失败：${res.data.Message}`, 4);
            }
        }, err => {
        });
    }
    pullFresh = () => {
        if (this.dataSource().data.Data.length < this.dataSource().data.Total) {
            this.setState({
                cardListRefreshing: true,
                filters: {
                    ...this.state.filters,
                    page: this.state.filters.page + 1
                }
            }, () => this.publicSelect(() => this.setState({
                cardListRefreshing: false
            })))
        }
        console.log(this.dataSource())
    }



    goToContent = (params, status) => {

        params.status = status;
        params.approvalType = "overtime";
        params.historyPath = "/mobile/mobile-approval-overtime-list";

        var path = {
            pathname:'/mobile/mobile-approval-content',
            state:params,
        }

        store.dispatch(push(path))
    }
    // adoptApply = (approval_status, approvalTypeStr, id) => {
    //     this.setState({
    //         currentModalStatus: true,
    //         approval_status:approval_status,
    //         approval_type:approvalTypeStr,
    //         document_id:id
    //     });
    // }

    // rejectApply = (approval_status, approvalTypeStr, id) =>  {
    //     this.setState({
    //         currentModalStatus: true,
    //         approval_status:approval_status,
    //         approval_type:approvalTypeStr,
    //         document_id:id
    //     });
    // }
    // handleChange = (event) => {

    //     this.setState({suggestion: event});
    // }
    // onSubmit = () => {
        
    //     if(this.state.suggestion == null || this.state.suggestion === ""){
    //         Toast.fail("请填写意见！", 4);
    //         return false;
    //     }
    //     let posts = {
    //         document_id: this.state.document_id,
    //         approval_status: this.state.approval_status,
    //         approval_type: this.state.approval_type,
    //         suggestion:this.state.suggestion
    //     }
    //     OvertimeApprovalService.updateOvertimeApproval(posts, res => {
    //         if (res.data.Success) {
    //             Toast.success("操作成功", 4);
    //             this.setState({suggestion: ""});
    //             this.setState({currentModalStatus: false});
    //             this.actions.changeAction({}, "reload") 
    //         } else if(res.data.Errors){
    //             Toast.fail(`操作失败：${res.data.Errors}`, 4);
    //         } else {
    //             Toast.fail(`操作失败：${res.data.Message}`, 4);
    //         }
    //     }, err => {
    //     });

    // }
    // onCancel= () => {
    //     this.setState({
    //         currentModalStatus: false,
    //         suggestion: ""
    //     });
    // }
    onChange = (e, val) => {

        if(e.target.checked){

            this.state.document_id.push(val);
            this.setState({document_id: this.state.document_id})


        } else {

           let newValue =  this.state.document_id.filter(function (id) {
                return id !== val;
            })

            this.setState({document_id: newValue})

        }


    }
    
    componentWillReceiveProps(nextProps) {
        // console.log(nextProps);
        let result = []; 
        if (nextProps.user.currentUser.PermissionDict.mobile_approval_overtime_list.to_apply_value) {
            result.push({
            title: '待审批',
            key: 'selectApprovalAction'
            })
        }
        if (nextProps.user.currentUser.PermissionDict.mobile_approval_overtime_list.to_me_value) {
            result.push({
            title: '抄送给我的',
            key: 'selectCCAction'
            })
        }
        if (nextProps.user.currentUser.PermissionDict.mobile_approval_overtime_list.approved_value) {
            result.push({
            title: '已审批记录',
            key: 'selectApprovedAction'
            })
        }
        this.setState({tabs:result})

        // console.log(this.props.user.currentUser.PermissionDict.mobile_approval);
        // console.log(this.state.tabsResult);
    }
    render() {

        return (
            <div>
                {this.state.tabs.length !== 0 &&
                <PullToRefresh
                    ref = {el => this.ptr = el}
                    style = {{
                        height: this.state.cardListHeight,
                        overflow: 'auto',
                    }}
                    direction = 'up'
                    refreshing = {this.state.cardListRefreshing}
                    onRefresh = {this.pullFresh} >
                    <WhiteSpace />
                    <Tabs tabs={this.state.tabs} 
                        initialPage={0}
                        animated={false}
                        useOnPan={false}
                        onChange={this.changeTabIndex} />
                    <WhiteSpace />
                    {"selectApprovalAction" === this.state.tabIndex && 
                    this.props.user.currentUser.PermissionDict.mobile_approval_overtime_list.accept_all_value &&
                    <Button type="primary"
                        size="small"
                        style={{width: "140px", float: "right"}}
                        onClick={_el => this.allApproval(1)}>
                        全部同意
                    </Button>}
                    <div style={{clear: "both"}}></div>
                    <div>{this.dataSource().data.Data && 
                        this.dataSource().data.Data.map((apply, index) => (
                        <div key={index}>
                            <WhiteSpace size="lg"/>
                            <Card full>
                                <Card.Header title={  <CheckboxItem key={apply.id} 
                                    onChange={(e) => this.onChange(e,apply.id)}>{apply.apply_type}</CheckboxItem> }
                                    extra={<span>{apply.approval_status_str}</span>} />
                                <Card.Body>
                                    <div>申请人: {apply.real_name} </div>
                                    <div>申请日期: {apply.created_time_str} </div>
                                    <div>加班日期: {apply.start_date} </div>
                                    <div>加班时间: {apply.start_time} - {apply.end_time}</div>
                                    <div>加班时长: {apply.hours_str}</div>
                                    <div>加班事由: {apply.remark}</div>
                                </Card.Body>
                                { apply.approval_status === 4 &&
                                    <Card.Footer content="" 
                                        extra={
                                        <div className="approvalButton"> 
                                            {this.props.user.currentUser.PermissionDict.mobile_approval_overtime_list.accept_value &&
                                            <Button style={{width: '140px', float:"left", marginRight: "5px"}} 
                                                size="small" type="primary" 
                                                // onClick={(e) => this.adoptApply(1,"加班审批",apply.id)}>通过
                                                onClick={(e) => this.goToContent(apply, true)}>通过
                                                
                                            </Button>}



                                            {this.props.user.currentUser.PermissionDict.mobile_approval_overtime_list.reject_value &&
                                            <Button style={{width: '140px', float:"left"}} 
                                                size="small" type="warning"
                                                    // onClick={(e) => this.rejectApply(2,"加班审批",apply.id )}>作废
                                                    onClick={(e) => this.goToContent(apply, false)}>驳回
                                                    
                                            </Button>}
                                            
                                        </div>} />
                                }
                            </Card>
                        </div>
                    ))}
                    <WhiteSpace />
                    {this.dataSource().data.Data.length >= this.dataSource().data.Total &&
                        <div style={{textAlign: "center"}}>没有更多数据了</div>
                    }
                    </div>    
                    <WhiteSpace />
                </PullToRefresh>}
                {/*<Modal visible={this.state.currentModalStatus} onClose={this.onCancel} title="审批">
                    {this.state.approval_type &&    
                        <List style={{backgroundColor: 'white'}} className="picker-list">

                            <TextareaItem
                                title="审批意见"
                                placeholder="审批意见"
                                value={this.state.suggestion}
                                rows={5}
                                onChange={this.handleChange}/>
                            <List.Item>
                            <div style={{width:"255px",margin:"0 auto"}}>
                                <Button type="primary" size="small" style={{width: "120px",marginRight:"15px",float:"left"}} onClick={this.onSubmit}>提交</Button>
                                <Button type="primary" size="small" style={{width: "120px",float:"left"}} onClick={this.onCancel}>返回</Button>
                            </div>  
                            </List.Item>
                        </List>
                    }
                </Modal>*/}
            </div>
        )
    }
}

// export default MobileWrapper(MobileApprovalOvertimeList);
const mapStateToProps = state => {
    return {
        user: state.user
    }
}
const mapDispatchToProps = {
}
export default MobileWrapper(connect(mapStateToProps, mapDispatchToProps)(MobileApprovalOvertimeList));




// WEBPACK FOOTER //
// ./src/routes/Mobile/MobileApprovalOvertimeList.js